import { format, getTime, formatDistanceToNow } from 'date-fns';

// ----------------------------------------------------------------------
// Safe date parsing helper with backend driver offset compensation (+5:30h)
const BACKEND_OFFSET_MS = 5.5 * 60 * 60 * 1000; // 5 hours 30 mins

function safeDate(date) {
  if (!date) return null;
  if (date instanceof Date) {
    return new Date(date.getTime() + BACKEND_OFFSET_MS);
  }
  if (typeof date === 'string') {
    const str = date.trim();
    if (!str.includes('Z') && !str.includes('+') && !str.includes('T') && !str.includes('t') && str.includes(' ')) {
      // Plain string from DB: "2026-08-18 05:08:04" -> treat as UTC
      const d = new Date(`${str.replace(' ', 'T')}Z`);
      return Number.isNaN(d.getTime()) ? null : d;
    }
    const d = new Date(str);
    if (!Number.isNaN(d.getTime())) {
      // ISO string from backend serialized via mysql2 with +05:30 -> add offset
      return new Date(d.getTime() + BACKEND_OFFSET_MS);
    }
  }
  const parsed = new Date(date);
  return Number.isNaN(parsed.getTime()) ? null : new Date(parsed.getTime() + BACKEND_OFFSET_MS);
}

export function fDate(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy';
  const d = safeDate(date);
  return d ? format(d, fm) : '';
}

export function fDateTime(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy p';
  const d = safeDate(date);
  return d ? format(d, fm) : '';
}

export function fTimestamp(date) {
  const d = safeDate(date);
  return d ? getTime(d) : '';
}

export function fToNow(date) {
  const d = safeDate(date);
  return d
    ? formatDistanceToNow(d, {
        addSuffix: true,
      })
    : '';
}
